// extracted by mini-css-extract-plugin
module.exports = {"tab_content_wrapper":"CompanyAlbum_tab_content_wrapper__BX1lf","mobile_album":"CompanyAlbum_mobile_album__9L0mB"};